export const GET_SAVED_LIST = 'GET_SAVED_LIST';
export const GET_SAVED_LIST_SUCCESS = 'GET_SAVED_LIST_SUCCESS';
export const UPDATE_SORT_SAVED_ITEMS = 'UPDATE_SORT_SAVED_ITEMS';
export const GET_SAVED_LIST_ERROR = 'GET_SAVED_LIST_ERROR';
export const DELETE_SAVED_LIST = 'DELETE_SAVED_LIST';
export const DELETE_SAVED_LIST_SUCCESS = 'DELETE_SAVED_LIST_SUCCESS';
export const DELETE_SAVED_LIST_ERROR = 'DELETE_SAVED_LIST_ERROR';
export const GET_LIST_CATEGORY = 'GET_LIST_CATEGORY';
export const GET_LIST_CATEGORY_SUCCESS = 'GET_LIST_CATEGORY_SUCCESS';
export const GET_LIST_CATEGORY_ERROR = 'GET_LIST_CATEGORY_ERROR';
export const SHARE_LIST = 'SHARE_LIST';
export const SHARE_LIST_RESET = 'SHARE_LIST_RESET';
export const SHARE_LIST_ERROR = 'SHARE_LIST_ERROR';
export const SHARE_LIST_SUCCESS = 'SHARE_LIST_SUCCESS';
export const DELETE_SAVED_LIST_SUCCESS_EVENT = 'DELETE_SAVED_LIST_SUCCESS_EVENT';
export const DELETE_SAVED_LIST_ERROR_EVENT = 'DELETE_SAVED_LIST_ERROR_EVENT';
export const ANALYTICS_PRODUCTS_PAGE_LOAD = 'ANALYTICS_PRODUCTS_PAGE_LOAD';
export const UPDATE_SAVED_LIST_SUCCESS = 'UPDATE_SAVED_LIST_SUCCESS';
export const UPDATE_MOST_WANTED = 'UPDATE_MOST_WANTED';
export const UPDATE_MOST_WANTED_IN_STORE = 'UPDATE_MOST_WANTED_IN_STORE';
export const DELETE_SAVED_LIST_ITEM = 'DELETE_SAVED_LIST_ITEM';
export const REMOVE_SAVED_LIST_ITEM = 'REMOVE_SAVED_LIST_ITEM';
export const MYLIST_CART_ADD_ANALYTICS = 'MYLIST_CART_ADD_ANALYTICS';
export const TOGGLE_MOST_WANTED_IN_LIST = 'TOGGLE_MOST_WANTED_IN_LIST';
export const TOGGLE_MOST_WANTED_IN_LIST_SUCCESS = 'TOGGLE_MOST_WANTED_IN_LIST_SUCCESS';
export const TOGGLE_MOST_WANTED_IN_LIST_ERROR = 'TOGGLE_MOST_WANTED_IN_LIST_ERROR';
export const GET_SAVED_LIST_GUEST = 'GET_SAVED_LIST_GUEST';
export const TRACK_ICON_EVENT = 'TRACK_ICON_EVENT';
export const STORE_LAST_REMOVED_ITEM = 'STORE_LAST_REMOVED_ITEM';
export const DELETE_LAST_REMOVED_ITEM = 'DELETE_LAST_REMOVED_ITEM';
